import _ from 'lodash'
import React, { useEffect, useRef } from 'react'
import moment from 'moment'
import { useHistory, withRouter } from 'react-router'
import { Link } from 'react-router-dom'
import { Button } from 'semantic-ui-react'
import useMarshallResponse from '../../../../../hooks/useMarshallResponse'
import PurchaseOrdersRepository from '../../../../../repositories/transactionsApi/PurchaseOrdersRepository'
import { BreadCrumb } from '../../../../common/breadCrumb/BreadCrumb'
import { ItemList } from '../../../../common/list/ItemList'
import useDataFetchingTransactionsApi from '../../../../../hooks/useDataFetchingTransactionsApi'
import { IN_LOCATION_VENDOR_PO_ADD, IN_LOCATION_VENDOR_PO, IN_LOCATION_VENDOR_PO_LINK } from '../../../../../routes/locationLayoutRoutes/VendorPORoutes'
import { ACTIONS } from '../../replenishment/constants'
import CustomSimpleCellFormatter from '../../../../common/list/CustomSimpleCellFormatter'
import { toast } from 'react-toastify'
import { IN_LOCATION_PO_ADD_EDIT } from '../../../../../routes/locationLayoutRoutes'

const actionBtnKey = 'actionBtn'

const gridModel = [
  {
    key: 'created',
    name: 'Date',
    width: 300,
    resizable: true,
    formatters: [value => moment(value).format('L')],
    serverResponseKey: 'created'
  },
  {
    key: 'status',
    name: 'Status',
    resizable: true,
    serverResponseKey: 'status'
  },
  {
    key: 'type',
    name: 'Type',
    width: 300,
    resizable: true,
    serverResponseKey: 'type'
  },
  {
    key: actionBtnKey,
    name: 'Actions',
    width: 300,
    resizable: true,
    serverResponseKey: CustomSimpleCellFormatter
  }
]
export const VendorDirectPOList = props => {
  const history = useHistory()
  let action
  const id = document.querySelector('.header').textContent.replace(' ', '')
  const {
    data,
    // errors,
    totalCount,
    page,
    term,
    totalPages,
    isLoading,
    onSearch,
    onPageChange
  } = useDataFetchingTransactionsApi(PurchaseOrdersRepository, {
    locationName: id,
    vendor: 'direct'
  })
  const notifiedRef = useRef(false)

  useEffect(() => {
    const notified = notifiedRef.current
    if (!notified) {
      launchPurchaseOrderNotification()
      notifiedRef.current = true
    }
  })

  const launchPurchaseOrderNotification = () => {
    const notifySuccess = message => toast(message)

    const purchaseOrderNotification =
      props.location.state?.purchaseOrderNotification

    if (
      purchaseOrderNotification &&
      !_.isEmpty(purchaseOrderNotification) &&
      purchaseOrderNotification.success
    ) {
      notifySuccess(purchaseOrderNotification.message)
      history.replace(props.location.pathname, null)
    }
  }

  const appendEditButtons = rows => {
    return rows.map(row => {

      let btnLabel
      switch (row.status) {
        case 'open':
          btnLabel = ACTIONS.edit
          action = ACTIONS.edit
          break
        case 'closed':
        case 'processing':
          btnLabel = ACTIONS.view
          action = ACTIONS.view
          break
        case 'draft':
          btnLabel = ACTIONS.edit
          action = ACTIONS.draft
          break
        default:
      }

      return {
        ...row,
        [actionBtnKey]: (
          <Button
            primary
            as={Link}
            to={IN_LOCATION_VENDOR_PO.replace(
              ':locationId',
              props.match.params.locationId
            )
              .replace(':action(add|edit|draft|view)', action)
              .replace(':poId', row.id)}
            size='mini'
            content={btnLabel.ucfirst()}
          />
        )
      }
    })
  }

  const rows = appendEditButtons(useMarshallResponse(gridModel, data))

  const topButtons = () => (
    <Button
      primary
      as={Link}
      to={IN_LOCATION_VENDOR_PO_ADD.replace(
        ':locationId',
        props.match.params.locationId
      )}
      content='Create'
    />
  )

  const bottomButtons = () => (
    <Button.Group floated='left'>
      <Button
        as={Link}
        to={IN_LOCATION_VENDOR_PO_LINK.replace(
          ':locationId',
          props.match.params.locationId
        )}
        labelPosition='left'
        icon='arrow left'
        content='Back'
      />
    </Button.Group>
  )

  return (
    <ItemList
      breadCrumb={<BreadCrumb route={props.route} />}
      columns={gridModel}
      showEdit
      isLoading={isLoading}
      rows={rows}
      rowCount={totalCount}
      totalRows={totalCount}
      onPageChanged={onPageChange}
      activePage={page}
      searchTerm={term}
      totalPages={totalPages}
      onSearch={onSearch}
      searchBy='reference'
      topButtons={topButtons()}
      bottomButtons={bottomButtons()}
      onRowDoubleClick={index => {
        history.push(IN_LOCATION_VENDOR_PO.replace(':locationId', props.match.params.locationId).replace(':action(add|edit|draft|view)', action).replace(':poId', rows[index].id))
      }}
    />
  )
}

export default withRouter(VendorDirectPOList)
